import type {RecruitmentsType} from '../../../core/entities/companyDetail/schema';
import {getSheduleEnd} from '../../../core/factories/recruitment/getScheduleEnd';

// 企業の募集一覧から、現在より後の締切（entryEnd/eventEnd）を持つ募集のみを抽出し、
// 締切が近い順に並べて返す
export const sortRecruitmentsByDeadline = (
  recruitments: RecruitmentsType,
  now: Date,
): RecruitmentsType => {
  return recruitments
    .map((recruitment) => ({
      recruitment,
      end: getSheduleEnd(recruitment.schedules, now).scheduleEnd,
    }))
    .filter(
      (item): item is {recruitment: RecruitmentsType[number]; end: Date} =>
        item.end !== null,
    )
    .sort((a, b) => a.end.getTime() - b.end.getTime())
    .map((item) => item.recruitment);
};
